import React from 'react';
import { Button } from 'antd';
import { ButtonProps as AntButtonProps, ButtonType } from 'antd/lib/button/button';
import './button.scss';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import classNames from 'classnames';

export interface ButtonProps extends Omit<AntButtonProps, 'children' | 'loading' | 'size' | 'type'> {
	children?: React.ReactNode[] | React.ReactNode;
	loading?: boolean;
	size?: SizeType | 'xlarge';
	type?: ButtonType | 'regular' | 'regular-link' | 'inline-link';
	className?: string;
}

const xLarge = 'xlarge';

const ButtonWrapper = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
	const { children, size, className, type: typeProp, ...otherProps } = props;
	const hasXLarge = size === xLarge;
	const isRegular = typeProp === 'regular';
	const isRegularLink = typeProp === 'regular-link';
	const isInlineLink = typeProp === 'inline-link';

	return (
		<Button
			ref={ref}
			className={classNames(
				'bringg-btn',
				{ 'btn-xlarge': hasXLarge },
				{ 'btn-regular': isRegular },
				{ 'btn-regular-link': isRegularLink },
				{ 'btn-inline-link': isInlineLink },
				className
			)}
			size={hasXLarge ? undefined : (size as SizeType)}
			type={isRegular ? undefined : (isRegularLink || isInlineLink) ? 'link' : (typeProp as ButtonType)}
			{...otherProps}
		>
			{children}
		</Button>
	);
});

ButtonWrapper.defaultProps = {
	size: 'middle',
	type: 'default'
};

// for enzyme test
ButtonWrapper.displayName = 'ButtonWrapper';

export default ButtonWrapper;
